import React from 'react';
import ReactDOM from 'react-dom';
import { isEqual } from 'lodash';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
//引入元素组件
import { Element } from '../elements/';
class CustomLayoutFlags extends React.Component {
	//加载自定义布局门户
	renderCustomLayout() {
		const { layoutid, layoutFlags, layoutHtml } = this.props;
        let _config = this.props.config;
   		if (layoutHtml) {
	        layoutFlags.map((layoutFlag, i) => {
	       		let lhtml = layoutFlag.areaElements.map(config => <Element ecId={`${this && this.props && this.props.ecId || ''}_Element@3wrojc@${"element-"+config.item.eid}`} key={"element-"+config.item.eid} config={{...config, layoutid, ..._config}}/>);
                let groupdom = $(".homepage[data-issetting="+_config.isSetting+"]").find(".group[areaflag='" + layoutFlag.areaflag + "']")[0] || $(".homepage[data-issetting="+_config.isSetting+"]").find(".group[data-areaflag='" + layoutFlag.areaflag + "']")[0];
                if(groupdom){
                    let renderdom = groupdom.parentNode;
                    ReactDOM.render(<div className="group" data-areaflag={layoutFlag.areaflag}>{lhtml}</div>,renderdom); 
                }
	        });
        }
    }
    componentDidMount() {
        this.renderCustomLayout();
    }
    componentDidUpdate(prevProps) {
        const prelayoutid = prevProps.layoutid;
        const { layoutid, config, layoutFlags } = this.props;
        if (prevProps.hpid !== this.props.hpid || prelayoutid !== layoutid || config.isRender || !isEqual(prevProps.layoutFlags, layoutFlags)) {
            this.renderCustomLayout();
        }
    }
    render() {
        let eHtml = <div></div>;
        const layoutHtml = this.props.layoutHtml;
        if (layoutHtml) {
            eHtml = <div dangerouslySetInnerHTML = {{ __html: layoutHtml }}></div>;
        }
        return <div>{eHtml}</div>
    }
}

import { WeaErrorPage, WeaTools } from 'ecCom';
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@9yby78`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
CustomLayoutFlags = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(CustomLayoutFlags);
export default CustomLayoutFlags;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/components/CustomLayoutFlags.js